module.exports = __webpack_public_path__ + "img/headerLogo.769309a4.png";